import React from 'react';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next'
import { reduxForm, getFormValues } from 'redux-form'
import classNames from 'classnames';

import store from '../../store/redux_store'
import {
  clearFilter,
  applyPreset,
  setDetailViewTab,
} from '../../actions/ui';
import { getDesignIdShirt } from "../../actions/general";
import { cleanContrasts } from "../../actions/render";
import {
  getLayout,
  getPresets,
} from '../../selectors/entities/config';
import {
  getSelectedAttrs,
  getSelectedButtons,
  getSelectedContrasts,
} from "../../selectors/entities/general";
import { getActivePreset } from '../../selectors/entities/ui';

import { Menu, MenuItem } from '../ui/Menu'
import Attr from "../ui/Attr/Attr";
import { Toggle, ToggleOption } from '../ui/Toggle';

import BuilderAttr from "../BuilderAttr/BuilderAttr";
import BuilderSidePreview from '../BuilderSidePreview';
import DetailFilter from '../DetailsFilters';
import MenuIcon from '../icons/MenuIcon';
import { SlideMenu } from '../Styled';

const ToggleBlock = ({ items }) => {
  if (items.length === 0) {
    return <span className='config-options-wrapper__tag'>НЕТ</span>
  }
  return (
    <div className="flex" >
      <div
        className='config-options-wrapper__tags-wrapper'
      >
        {items.map((d, i) => (
          <span
            key={i}
            className='config-options-wrapper__tag'
          >
            {typeof d === 'string' ? `"${d}"` : d.displayName}
          </span>
        ))}
      </div>
    </div>
  )
}


const ShortSectionListItem = ({ children, isActive, onSelect }) => (
  <li
    className={
      classNames(
        'config-options-wrapper__short-list-item',
        {
          'config-options-wrapper__short-list-item_selected':
            isActive
        }
      )
    }
    onClick={onSelect}
  >
    {children}
  </li>
)

const ShortSectionsList = ({
  sections,
  checked,
  onChange,
  onSelectBack,
  visible
}) => {

  const items = sections.map(({ sectionName, displayName }, i) => {
    const isActive = sectionName == checked;
    return (
      <ShortSectionListItem
        key={`short-item-list-item-${i}`}
        sectionName={sectionName}
        isActive={isActive}
        onSelect={() => onChange(sectionName)}
      >
        {displayName}
      </ShortSectionListItem>
    )
  })

  return (
    !visible ?
      null :
      <div className='config-options-wrapper__short-list-container'>
        <ul className='config-options-wrapper__short-list'>
          {items}
          <ShortSectionListItem
            onSelect={onSelectBack}
          >
            <div className='config-options-wrapper__back-icon'>
              <MenuIcon />&nbsp;
              <div>ВСЕ</div>
            </div>
          </ShortSectionListItem>
        </ul>
      </div>
  )
};


class WrapperAttr extends React.Component {
  render() {
    return (

      <div className="config-options-content">
        <form name="detail" >
          {this.props.children}
        </form>
      </div>

    )
  }
}

class BuilderDetail extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      openAttr: false,
      selectedAttr: '',
      sectionName: '',
      SnackbarIsOpened: true,
    }
  }

  changeAttrTop = (event, value) => {
    store.dispatch(setDetailViewTab(value))
  }

  changeAttr = (value) => {
    store.dispatch(setDetailViewTab(value))
  }

  closeAttr = (value) => {
    store.dispatch(setDetailViewTab(''))
  }


  getSnackStatus = () => {
    return this.props.updateRender.Collar
  }

  openSnackbar = type => {
    this.setState({
      SnackbarIsOpened: true
    })
  }

  closeSnackbar = type => {
    this.setState({
      SnackbarIsOpened: false
    })
  }

  onFilterChange = (filterValue) => {
    this.props.actions.applyPreset(filterValue);
    // Сбросить контрасты
    this.props.actions.cleanContrasts();
  }

  onFilterClear = () => {
    this.props.actions.clearFilter('styles');
  }

  getSelectedDetailName(sectionName) {

    const purify = (a) => a.filter(e => e);

    const {
      selectedParts,
      selectedButtons, selectedContrasts
    } = this.props;

    const { buttonThreadDecor } = selectedParts;

    let items = [];
    if (sectionName === 'buttons') {
      const buttonThreads = purify([buttonThreadDecor]);
      items = [...Object.values(selectedButtons), ...buttonThreads];
    }

    else if (sectionName === 'contrast') {
      for (let c in selectedContrasts) {
        const contrast = selectedContrasts[c];
        items.push({
          ...contrast,
          displayName: `${contrast.displayName} - ${contrast.shortName}`
        });
      }
    }

    else if (sectionName === 'collar') {
      const {
        collar,
        collarDensity,
        collarButtons,
        collarBone
      } = selectedParts;

      items = purify([
        collar,
        collarDensity,
        collarButtons,
        collarBone
      ]);
    }

    else if (sectionName === 'sleeve') {
      const {
        sleeve,
        cuffStyle,
        cuff,
        cuffDensity,
      } = selectedParts;

      items = purify([
        sleeve,
        cuff,
        cuffStyle,
        cuffDensity,
      ]);
    }

    else if (sectionName === 'fastening') {
      const { fastening } = selectedParts;
      items = purify([fastening]);
    }

    else if (sectionName === 'backPleats') {
      const {
        suspended,
        collarDecor,
        cuffDecor,
        epaulettes,
        patch,
        backPleats,
      } = selectedParts;

      items = purify([
        backPleats,
        suspended,
        collarDecor,
        cuffDecor,
        epaulettes,
        patch,
      ]);

    }

    else if (sectionName === 'pocket') {
      const {
        pocket,
        pocketFlap,
        pocketButton,
      } = selectedParts;
      items = purify([pocket, pocketFlap, pocketButton]);
    }

    else if (sectionName === 'embroidery') {
      const {
        embroideryColor,
        embroideryFont,
        printProductNumber,
        embroidery,
        embroideryText,
      } = selectedParts;

      items = purify([
        printProductNumber,
        embroideryText,
        embroideryFont,
        embroideryColor,
        embroidery,
      ]);

    }

    else if (sectionName === 'volume') {
      const {
        volume,
      } = selectedParts;
      items = purify([volume]);
    }

    return items.length > 0 ?
      (<ToggleBlock items={items} />) :
      (<span>НЕТ</span>);
  }


  async componentWillUnmount() {
    await this.props.actions.getDesignIdShirt()
  }

  shouldComponentUpdate = (nextProps) => {
    return this.props.viewedTab !== nextProps.viewedTab ||
      this.props.isMobile !== nextProps.isMobile ||
      this.props.activePreset !== nextProps.activePreset;
  }

  render() {

    const {
      layout,
      availablePresets,
      viewedTab,
      activePreset,
      isMobile,
    } = this.props

    const sections = Object.values(layout.sections);

    const toggleOptionStyle = {
      margin: 0,
      border: 'none',
      padding: '9px 13px',
      height: 'min-content',
      fontSize: '12px',
      borderRadius: '2px',
      boxSizing: 'border-box',
      lineHeight: 'normal',
      marginRight: '2px'
    }

    let toggles = [
      <ToggleOption key={'all'} value={''} style={toggleOptionStyle}>
        &#9776;&nbsp;{'Все'}
      </ToggleOption>]

    sections.forEach((item, i) => {
      !item.hiddenMenuItem &&
        toggles.push(
          <ToggleOption key={i} value={item.sectionName} style={toggleOptionStyle}>
            {item.displayName}
          </ToggleOption>)
    })

    let sideMenu;
    if (Boolean(viewedTab)) {
      sideMenu = (
        <SlideMenu>
          <ShortSectionsList
            visible={true}
            onChange={this.changeAttr}
            onSelectBack={this.closeAttr}
            checked={viewedTab}
            sections={sections}
          />
        </SlideMenu>
      );
    }

    return (

      <div className='b-builder-fabric'>
        {sideMenu}
        <div className='config-options-wrapper'>
          <div className={'mobile-menu'}>
            <div className={'mobile-menu-wrapper'}>
              <Toggle
                value={viewedTab}
                className="toggle"
                block={false}
                equalWidth={false}
                variation={'center'}
                onChange={this.changeAttrTop}
                style={{ width: 'max-content' }}
              >
                {toggles}
              </Toggle>
            </div>
          </div>


          <WrapperAttr>
            {!viewedTab &&
              <div className='flex flex-column'>

                <Attr
                  showClose={false}
                  isOpened={!viewedTab}
                  className='config-options-wrapper__attr'
                  backdropColor="black"
                  style={isMobile ? {
                    background: '#f1f1f1'
                  } : null}>
                  <DetailFilter
                    availableStyles={Object.values(availablePresets)}
                    selectedStyle={activePreset}
                    handleFilterChange={this.onFilterChange}
                    handleFilterClear={this.onFilterClear}
                    isMobile={isMobile}
                  />
                  <Menu
                    value={viewedTab}
                    onChange={this.changeAttr}
                  >
                    {sections.map((item, index) => {
                      return (!item.hiddenMenuItem &&
                        <MenuItem
                          style={isMobile ? {
                            padding: '12px 0 12px 12px',
                            borderBottom: '1px solid #E3E3E3'
                          } : null}
                          className='config-options-wrapper__menu-item-wrap'
                          key={index}
                          value={item.sectionName}
                        >
                          <label className="config-options-wrapper__menu-item">
                            <div>
                              {item.displayName}
                            </div>
                            <div className='config-options-wrapper__menu-name'>
                              {this.getSelectedDetailName(item.sectionName)}
                            </div>
                          </label>
                        </MenuItem>)
                    })}
                  </Menu>
                </Attr>

              </div>
            }
            {viewedTab &&

              <Attr
                closeOnEsc={false}
                showClose={!isMobile}
                isOpened={Boolean(viewedTab)}
                backdropColor="black"
                onRequestClose={this.closeAttr}>
                <BuilderAttr sectionName={viewedTab}
                />
                {isMobile && <BuilderSidePreview type='detail' />}
              </Attr>
            }
          </WrapperAttr>
        </div>
      </div>
    );
  }
}

BuilderDetail.propTypes = {
  layout: PropTypes.object.isRequired,
  availablePresets: PropTypes.object.isRequired,
  selectedParts: PropTypes.object.isRequired,
  selectedButtons: PropTypes.object.isRequired,
  selectedContrasts: PropTypes.object.isRequired,
  activePreset: PropTypes.object.isRequired,
  viewedTab: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,

  actions: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
};

const formValues = getFormValues('detail');

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    layout: getLayout(state),
    availablePresets: getPresets(state),
    selectedParts: getSelectedAttrs(state),
    selectedButtons: getSelectedButtons(state),
    selectedContrasts: getSelectedContrasts(state),
    activePreset: getActivePreset(state),
    viewedTab: state.ui.selectedDetailTab,
    isMobile: state.ui.isMobile,
    initialValues: {
      sleeveType: 'sleeveLong',
      ...formValues(state),
    }
  };
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        applyPreset,
        clearFilter,
        getDesignIdShirt,
        cleanContrasts,
      }, dispatch)
  };
}


BuilderDetail.whyDidYouRender = false;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(
  reduxForm({
    form: 'detail',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })(BuilderDetail))
);
